"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningIcon = function WarningIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "25px", height: "25px", viewBox: "0 0 40 40" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-24.000000, -79.000000)" },
        _react2.default.createElement(
          "g",
          { transform: "translate(0.000000, 56.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(24.000000, 23.000000)" },
            _react2.default.createElement("rect", { x: "0", y: "0", width: "40", height: "40" }),
            _react2.default.createElement(
              "g",
              { transform: "translate(4.666667, 6.000000)", fill: "#8DB8FF" },
              _react2.default.createElement("path", { d: "M30.2815457,23.0224951 L17.8339321,1.41529612 C16.7725398,-0.471765372 13.8777286,-0.471765372 12.8162684,1.41529612 L0.368722701,23.0224951 C-0.692669629,24.9094903 0.658224176,27.2684498 2.87755456,27.2684498 L27.676236,27.2684498 C29.9919764,27.17411 31.342938,24.9094903 30.2815457,23.0224951" })
            ),
            _react2.default.createElement("polygon", { fill: "#FFFFFF", points: "20.0116336 8.33333333 32.4900017 30.4848224 7.53333346 30.4848224" }),
            _react2.default.createElement("path", {
              d: "M19.284464,21.9853951 L19.0571282,18.5824625 C19.0145025,17.9193964 18.99319,17.4434169 18.99319,17.1545095 C18.99319,16.7614061 19.0962005,16.4547426 19.3022246,16.23451 C19.5082487,16.0142773 19.7793913,15.9041626 20.1156605,15.9041626 C20.5229725,15.9041626 20.7952991,16.0450621 20.9326485,16.3268651 C21.0699979,16.6086682 21.1386715,17.0147901 21.1386715,17.5452429 C21.1386715,17.8578312 21.1220951,18.1751509 21.0889418,18.4972115 L20.7834594,21.9996036 C20.7503061,22.416388 20.6792643,22.7360758 20.5703321,22.9586765 C20.4613998,23.1812772 20.2814274,23.2925759 20.0304095,23.2925759 C19.7746555,23.2925759 19.5970512,23.1848293 19.4975913,22.9693329 C19.3981314,22.7538364 19.3270896,22.4258604 19.284464,21.9853951 Z M20.073035,26.6599874 C19.7841277,26.6599874 19.5319295,26.5664491 19.3164331,26.3793698 C19.1009366,26.1922904 18.99319,25.9306201 18.99319,25.5943509 C18.99319,25.3007073 19.0962005,25.0508773 19.3022246,24.8448532 C19.5082487,24.6388291 19.7604468,24.5358186 20.0588265,24.5358186 C20.3572062,24.5358186 20.6117724,24.6388291 20.8225327,24.8448532 C21.033293,25.0508773 21.1386715,25.3007073 21.1386715,25.5943509 C21.1386715,25.9258839 21.032109,26.1863702 20.8189806,26.3758177 C20.6058522,26.5652651 20.3572062,26.6599874 20.073035,26.6599874 Z",
              fill: "#417FD0"
            })
          )
        )
      )
    )
  );
};

exports.default = WarningIcon;